export class UserAddress{
    pk?: number;
    street_1?: string;
    street_2?: string | null;
    city?: string;
    parish?: string;
    postOffice?: string; 
    user?: number;
}